import React from "react";
import { Container } from "../../components/container/Container";
import { Card } from "../../components/card/Card";
import Image from "../../components/image/Image";
import Heading from "../../components/heading/Heading";

const CardWithImageOrTitle = ({ data }) => {
  return (
    <Container className="flex items-center justify-center px-4 py-10">
      <Container className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-16 w-full max-w-7xl">
        {data.map((item, index) => (
          <Card
            key={index}
            className={`w-full group flex flex-col items-center justify-center space-y-2 transition-all duration-300 hover:shadow-xl hover:scale-105 rounded-xl bg-white ${
              item.src
                ? "h-60 p-2"
                : "h-24 border border-gray-300 text-center hover:shadow-xl hover:scale-105 hover:bg-gradient-to-br hover:from-blue-50 hover:to-blue-100"
            }`}
          >
            {item.src ? (
              <Image
                src={item.src}
                alt={item.alt}
                className="w-32 h-32 object-contain"
              />
            ) : (
              <div className="flex-1 flex items-center justify-center w-full"></div>
            )}
            <Heading
              level="h6"
              className="font-semibold text-xl text-center group-hover:text-[#0F6CB4]"
            >
              {item.title}
            </Heading>
          </Card>
        ))}
      </Container>
    </Container>
  );
};

export default CardWithImageOrTitle;
